import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/hamburgur.png'
import _imports_1 from '@/assets/img/logo.png'
import _imports_2 from '@/assets/img/narrow-down-vector.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-34173666")

_pushScopeId("data-v-34173666")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "hamburgur-box" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_1
}, null, -1)
const _hoisted_5 = { class: "menu-box" }
const _hoisted_6 = { class: "menu-box-list" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("TOP")
const _hoisted_8 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    class: "menu-list txt txt-small",
    href: "https://onlylive.tokyo/howto",
    target: "_blank"
  }, "初めての方はこちら")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    class: "menu-list txt txt-small",
    href: "https://onlylive.tokyo/contact",
    target: "_blank"
  }, "お問い合わせ")
], -1)
const _hoisted_10 = {
  class: "menu-list register-button",
  href: "https://onlylive.tokyo/talent",
  target: "_blank"
}
const _hoisted_11 = {
  key: 0,
  class: "dropdown-login-menu-container"
}
const _hoisted_12 = {
  key: 0,
  class: "dropdown-login-menu-list",
  role: "menu"
}
const _hoisted_13 = { role: "none" }
const _hoisted_14 = { class: "dropdown-menu-icon" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "コイン購入", -1)
const _hoisted_16 = { role: "none" }
const _hoisted_17 = { class: "dropdown-menu-icon" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "ログアウト", -1)
const _hoisted_19 = {
  key: 0,
  class: "dropdpwn-top-menu-container"
}
const _hoisted_20 = { class: "dropdown-top-menu-box" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("TOP")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")
  const _component_SignInModal = _resolveComponent("SignInModal")
  const _component_AppDownloadModal = _resolveComponent("AppDownloadModal")
  const _component_ProfileIcon = _resolveComponent("ProfileIcon")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          class: "hamburgur",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args))),
          src: _imports_0
        })
      ]),
      _createVNode(_component_router_link, {
        class: "logo-box",
        to: { name: 'TopScreen' }
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode("ul", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "menu-list txt txt-small",
              to: "/"
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _hoisted_8,
          _hoisted_9,
          _createVNode("li", null, [
            _createVNode("p", {
              class: "menu-list txt txt-small",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
            }, "アプリダウンロード")
          ])
        ]),
        _createVNode("a", _hoisted_10, [
          _createVNode(_component_BaseRoundRectButton, {
            class: "register-button",
            text: "タレント登録"
          })
        ]),
        (!_ctx.state.isLogined && !_ctx.isPasswordResetPage)
          ? (_openBlock(), _createBlock(_component_BaseRoundRectButton, {
              key: 0,
              class: "menu-list login-button",
              text: "ログイン",
              isPushed: _ctx.isPushed,
              onClick: _ctx.openSignInModal
            }, null, 8, ["isPushed", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.state.isOpenSignInModal)
          ? (_openBlock(), _createBlock(_component_SignInModal, {
              key: 1,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.isOpenSignInModal = false))
            }))
          : _createCommentVNode("", true),
        (_ctx.state.isOpenModal)
          ? (_openBlock(), _createBlock(_component_AppDownloadModal, {
              key: 2,
              imageUrl: _ctx.imageUrl,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.isOpenModal = false))
            }, null, 8, ["imageUrl"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.state.isLogined && !_ctx.isPasswordResetPage)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("button", {
              class: "dropdown-login-menu",
              type: "button",
              "aria-label": "アカウントメニュー",
              "aria-haspopup": "menu",
              "aria-expanded": _ctx.state.isOpened,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)))
            }, [
              _createVNode(_component_ProfileIcon),
              _createVNode("img", {
                class: ["header-vector", { 'header-vector-open': _ctx.state.isOpened }],
                src: _imports_2,
                alt: "",
                "aria-hidden": "true"
              }, null, 2)
            ], 8, ["aria-expanded"]),
            _createVNode(_Transition, { name: "account-menu" }, {
              default: _withId(() => [
                (_ctx.state.isOpened)
                  ? (_openBlock(), _createBlock("ul", _hoisted_12, [
                      _createVNode("li", _hoisted_13, [
                        _createVNode("button", {
                          class: "dropdown-text",
                          type: "button",
                          role: "menuitem",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toShop && _ctx.toShop(...args)))
                        }, [
                          _createVNode("span", _hoisted_14, [
                            _createVNode(_component_font_awesome_icon, { icon: "coins" })
                          ]),
                          _hoisted_15
                        ])
                      ]),
                      _createVNode("li", _hoisted_16, [
                        _createVNode("button", {
                          class: "dropdown-text",
                          type: "button",
                          role: "menuitem",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, [
                          _createVNode("span", _hoisted_17, [
                            _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" })
                          ]),
                          _hoisted_18
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.openedDropdown)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("ul", _hoisted_20, [
            _createVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "txt txt-small dropdown-top-menu-text",
                onClick: _ctx.closeMenu,
                to: "/"
              }, {
                default: _withId(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("li", null, [
              _createVNode("a", {
                class: "txt txt-small dropdown-top-menu-text",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
                href: "https://onlylive.tokyo/howto",
                target: "_blank"
              }, "初めての方はこちら")
            ]),
            _createVNode("li", null, [
              _createVNode("a", {
                class: "txt txt-small dropdown-top-menu-text",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
                href: "https://onlylive.tokyo/contact",
                target: "_blank"
              }, "お問い合わせ")
            ]),
            _createVNode("li", null, [
              _createVNode("p", {
                class: "txt txt-small dropdown-top-menu-text",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
              }, "アプリダウンロード")
            ]),
            _createVNode("li", null, [
              _createVNode("a", {
                class: "txt txt-small dropdown-top-menu-text",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
                href: "https://onlylive.tokyo/talent",
                target: "_blank"
              }, "タレント登録")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})